export const color = {
    grey: "#d8d8d8",
    greyLight: "#f1f1f1",
    greyDark: "#343434",
    greyMiddle: "#a0a0a0",
    grayText: "#777777",
    orange: "#f46f46",
    paleOrange: "#D9C4B4"
};
